import { IconGrid16 } from '@warp-ds/icons/react/grid-16';
import { IconListSort16 } from '@warp-ds/icons/react/list-sort-16';
import { Button } from '@warp-ds/react';
import React from 'react';
import { useLayoutCookieState } from './LayoutCookieState';
import { useLayout } from './LayoutStore';

export function LayoutToggle() {
    const { layout, setLayout } = useLayout();

    useLayoutCookieState();

    const toggleLayout = React.useCallback(() => {
        const updatedLayout = layout === 'grid' ? 'list' : 'grid';
        setLayout(updatedLayout);
    }, [layout, setLayout]);

    return (
        <Button className="flex items-center" onClick={toggleLayout} utility>
            {layout === 'grid' ? <IconListSort16 /> : <IconGrid16 />}
        </Button>
    );
}
